import script from "./staMon.vue?vue&type=script&setup=true&lang=js"
export * from "./staMon.vue?vue&type=script&setup=true&lang=js"

import "./staMon.vue?vue&type=style&index=0&id=25e611b1&lang=css"

const __exports__ = script;

export default __exports__